import { ExternalLink } from 'lucide-react';
import type { ReactNode } from 'react';

import Typo from '@/components/Typography/Typo';
import { Tooltip } from '@/shared/ui/tooltip';

type FeedbackGalleryCardHeaderProps = {
  sourceName: string;
  sourceIcon?: ReactNode;
  title: string;
  profileMeta: string;
  originHref?: string;
  getTooltipContent: (label: string, value: string) => ReactNode;
};

const FeedbackGalleryCardHeader = ({
  sourceName,
  sourceIcon,
  title,
  profileMeta,
  originHref,
  getTooltipContent,
}: FeedbackGalleryCardHeaderProps) => {
  return (
    <div className="flex items-start justify-between gap-2 px-4 py-3">
      <div className="flex min-w-0 flex-1 items-center gap-2">
        <Tooltip
          disableHoverableContent
          content={getTooltipContent('Source', sourceName)}
        >
          <div className="flex size-6 shrink-0 items-center justify-center rounded-full">
            {sourceIcon || (
              <Typo type="label5" weight="sb">
                {(sourceName || '?')[0]?.toUpperCase()}
              </Typo>
            )}
          </div>
        </Tooltip>
        <div className="min-w-0 space-y-0.5">
          <Tooltip
            disableHoverableContent
            content={getTooltipContent('Title', title)}
          >
            <Typo type="body3" weight="l" className="truncate">
              {title}
            </Typo>
          </Tooltip>
          <Tooltip
            disableHoverableContent
            content={getTooltipContent('Profile', profileMeta)}
          >
            <Typo type="label5" className="truncate text-[rgb(140,139,133)]">
              {profileMeta}
            </Typo>
          </Tooltip>
        </div>
      </div>
      {originHref && (
        <Tooltip
          disableHoverableContent
          content={getTooltipContent('Origin', originHref)}
        >
          <a
            href={originHref}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(event) => {
              event.stopPropagation();
            }}
            aria-label="Open origin link"
            className="flex h-6 w-6 shrink-0 items-center justify-center rounded-md text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
          >
            <ExternalLink size={14} />
          </a>
        </Tooltip>
      )}
    </div>
  );
};

export default FeedbackGalleryCardHeader;

